var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCartLine24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.505 5.5c-.8 0-2-.12-2.57-.7-.24-.25-.38-.52-.42-.8-.06-.46.06-.86.34-1.14.28-.28.68-.39 1.14-.34.28.03.55.17.8.42.58.57.71 1.77.7 2.57M21.505 5.5h-16M5.505 5.5l1.65 7.43c.2.92 1.01 1.57 1.95 1.57h8.8c.94 0 1.75-.65 1.95-1.57l.982-4.43M17.505 21.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM8.505 21.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM15.505 19.5h-5",
  stroke: "#222B3E",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.505 14.5c-1.52 0-2.63 1.43-2.24 2.9l.12.45",
  stroke: "#222B3E",
  strokeWidth: 1.65,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcCartLine24X24;